import { IFilterMultiSelectOption } from 'transfix-ui/components/FilterMultiSelect'
import { TQuoteFilters } from '../../../types'
import { getFilterMultiSelectedValues } from '../utils/getFilterMultiSelectedValues'

interface IUseEquipmentProps {
  quotesFilters: TQuoteFilters
  setQuotesFilters: React.Dispatch<React.SetStateAction<TQuoteFilters>>
}

export const useEquipment = ({ quotesFilters, setQuotesFilters }: IUseEquipmentProps) => {
  const getEquipmentFilterOptions = (quotesFilters: TQuoteFilters) => {
    const equipmentOptions: IFilterMultiSelectOption[] = [
      {
        value: '3',
        label: 'Dry Van',
        selected: quotesFilters.equipmentParentId.includes('3'),
      },
      {
        value: '2',
        label: 'Reefer',
        selected: quotesFilters.equipmentParentId.includes('2'),
      },
      {
        value: '1',
        label: 'Flatbed',
        selected: quotesFilters.equipmentParentId.includes('1'),
      },
    ]

    return equipmentOptions
  }

  const equipmentHandler = (selected?: IFilterMultiSelectOption[]) => {
    if (selected) {
      const updatedFilters = {
        ...quotesFilters,
        equipmentParentId: getFilterMultiSelectedValues(selected),
      }
      setQuotesFilters(updatedFilters)
    }
  }

  const equipmentOptions = getEquipmentFilterOptions(quotesFilters)

  return { equipmentOptions, equipmentHandler }
}
